<template>
  <div class="fill-height">
    <v-app-bar
      :clipped-left="$vuetify.breakpoint.smAndUp"
      color="primary"
      src="/assets/bg.jpg"
      dark
      fixed
      app
      class="header-toolbar"
    >
      <v-toolbar-title class="headline">
        <v-list-item href="/">
          <v-list-item-content>
            <v-list-item-title class="headline">{{ $t("admin.header.title") }}</v-list-item-title>
            <v-list-item-subtitle>{{ $t("admin.header.poweredBy") }}</v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
        <v-spacer></v-spacer>
        <v-toolbar-items class="hidden-sm-and-down"> </v-toolbar-items>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <lang-switcher />
    </v-app-bar>
    <v-main>
      <v-slide-x-reverse-transition mode="out-in">
        <v-container :key="pageKey" fluid>
          <router-view></router-view>
        </v-container>
      </v-slide-x-reverse-transition>
    </v-main>
  </div>
</template>

<script>
import LangSwitcher from "../../common/_langSwitcher";

export default {
  components: { LangSwitcher },
  data() {
    return {
      drawer: null,
      accounts: [],
    };
  },
  async mounted() {},
};
</script>

<style scoped>
.snackstack {
  top: 65px;
  position: fixed;
  z-index: 1111;
  width: 100%;
}

.snackstack .v-snack {
  position: relative;
  margin-top: 6px;
}
</style>
